import { UserACL } from '../UserManagement/Types';

export enum IAppsManagementActionTypes {
	ADD_GROUP_CHANNELS = '@@appsManagement/ADD_GROUP_CHANNELS',
	ADD_GROUP_CHANNELS_MT = '@@appsManagement/ADD_GROUP_CHANNELS_MT',
	ADD_GROUP_CHANNELS_TPP = '@@appsManagement/ADD_GROUP_CHANNELS_TPP',
	ADD_GROUP_CHANNELS_STT = '@@appsManagement/ADD_GROUP_CHANNELS_STT',
	ADD_USER_CHANNELS = '@@appsManagement/ADD_USER_CHANNELS',
	ADD_USER_CHANNELS_TPP = '@@appsManagement/ADD_USER_CHANNELS_TPP',
	ADD_USER_CHANNELS_STT = '@@appsManagement/ADD_USER_CHANNELS_STT',
	GET_ALL_MEDIAS = '@@appsManagement/GET_ALL_MEDIAS',
	GET_ALL_MEDIAS_FAILED = '@@appsManagement/GET_ALL_MEDIAS_FAILED',
	GET_ALL_MEDIAS_SUCCEED = '@@appsManagement/GET_ALL_MEDIAS_SUCCEED',
	GET_CHANNELS_FROM_USER = '@@appsManagement/GET_CHANNELS_FROM_USER',
	GET_CHANNELS_FROM_USER_FAILED = '@@appsManagement/GET_CHANNELS_FROM_USER_FAILED',
	GET_CHANNELS_FROM_USER_SUCCEED = '@@appsManagement/GET_CHANNELS_FROM_USER_SUCCEED',
	GET_CHANNELS_FROM_USER_STT = '@@appsManagement/GET_CHANNELS_FROM_USER_STT',
	GET_CHANNELS_FROM_USER_STT_FAILED = '@@appsManagement/GET_CHANNELS_FROM_USER_STT_FAILED',
	GET_CHANNELS_FROM_USER_STT_SUCCEED = '@@appsManagement/GET_CHANNELS_FROM_USER_STT_SUCCEED',
	GET_CHANNELS_FROM_USER_MT = '@@appsManagement/GET_CHANNELS_FROM_USER_MT',
	GET_CHANNELS_FROM_USER_MT_FAILED = '@@appsManagement/GET_CHANNELS_FROM_USER_MT_FAILED',
	GET_CHANNELS_FROM_USER_MT_SUCCEED = '@@appsManagement/GET_CHANNELS_FROM_USER_MT_SUCCEED',
	GET_CHANNELS_FROM_USER_TPP = '@@appsManagement/GET_CHANNELS_FROM_USER_TPP',
	GET_CHANNELS_FROM_USER_TPP_FAILED = '@@appsManagement/GET_CHANNELS_FROM_USER_TPP_FAILED',
	GET_CHANNELS_FROM_USER_TPP_SUCCEED = '@@appsManagement/GET_CHANNELS_FROM_USER_TPP_SUCCEED',
	GET_GROUPS_AND_USERS_FROM_CHANNEL = '@@appsManagement/GET_GROUPS_AND_USERS_FROM_CHANNEL',
	GET_GROUPS_AND_USERS_FROM_CHANNEL_FAILED = '@@appsManagement/GET_GROUPS_AND_USERS_FROM_CHANNEL_FAILED',
	GET_GROUPS_AND_USERS_FROM_CHANNEL_SUCCEED = '@@appsManagement/GET_GROUPS_AND_USERS_FROM_CHANNEL_SUCCEED',
	GET_GROUPS_AND_USERS_FROM_CHANNEL_STT = '@@appsManagement/GET_GROUPS_AND_USERS_FROM_CHANNEL_STT',
	GET_GROUPS_AND_USERS_FROM_CHANNEL_STT_FAILED = '@@appsManagement/GET_GROUPS_AND_USERS_FROM_CHANNEL_STT_FAILED',
	GET_GROUPS_AND_USERS_FROM_CHANNEL_STT_SUCCEED = '@@appsManagement/GET_GROUPS_AND_USERS_FROM_CHANNEL_STT_SUCCEED',
	GET_GROUPS_FROM_CHANNEL_MT = '@@appsManagement/GET_GROUPS_AND_USERS_FROM_CHANNEL_MT',
	GET_GROUPS_FROM_CHANNEL_MT_FAILED = '@@appsManagement/GET_GROUPS_AND_USERS_FROM_CHANNEL_MT_FAILED',
	GET_GROUPS_FROM_CHANNEL_MT_SUCCEED = '@@appsManagement/GET_GROUPS_AND_USERS_FROM_CHANNEL_MT_SUCCEED',
	GET_GROUPS_AND_USERS_FROM_CHANNEL_TPP = '@@appsManagement/GET_GROUPS_AND_USERS_FROM_CHANNEL_TPP',
	GET_GROUPS_AND_USERS_FROM_CHANNEL_TPP_FAILED = '@@appsManagement/GET_GROUPS_AND_USERS_FROM_CHANNEL_TPP_FAILED',
	GET_GROUPS_AND_USERS_FROM_CHANNEL_TPP_SUCCEED = '@@appsManagement/GET_GROUPS_AND_USERS_FROM_CHANNEL_TPP_SUCCEED',
	GET_MEDIA = '@@appsManagement/GET_MEDIA',
	GET_MEDIA_FAILED = '@@appsManagement/GET_MEDIA_FAILED',
	GET_MEDIA_SUCCEED = '@@appsManagement/GET_MEDIA_SUCCEED',
	RESET_MEDIAS = '@@appsManagement/RESET_MEDIAS',
	REMOVE_GROUP_CHANNELS_MT = '@@appsManagement/REMOVE_GROUP_CHANNELS_MT',
	SET_ALL_CHANNELS_FILTER = '@@appsManagement/SET_ALL_CHANNELS_FILTER',
	SET_GROUP_CHANNELS = '@@appsManagement/SET_GROUP_CHANNELS',
	SET_GROUP_CHANNELS_TPP = '@@appsManagement/SET_GROUP_CHANNELS_TPP',
	SET_GROUP_CHANNELS_STT = '@@appsManagement/SET_GROUP_CHANNELS_STT',
	SET_LOADING_CHANNELS_FROM_USER = '@@appsManagement/SET_LOADING_CHANNELS_FROM_USER',
	SET_LOADING_GROUPS_AND_USERS_FROM_CHANNEL = '@@appsManagement/SET_LOADING_GROUPS_AND_USERS_FROM_CHANNEL',
	SET_LOADING_MEDIAS = '@@appsManagement/SET_LOADING_MEDIAS',
	SET_USER_CHANNELS = '@@appsManagement/SET_USER_CHANNELS',
	SET_USER_CHANNELS_MT = '@@appsManagement/SET_USER_CHANNELS_MT',
	SET_USER_CHANNELS_STT = '@@appsManagement/SET_USER_CHANNELS_STT',
	SET_USER_CHANNELS_TPP = '@@appsManagement/SET_USER_CHANNELS_TPP',
	SET_USER_CHANNELS_SUCCEED = '@@appsManagement/SET_USER_CHANNELS_SUCCEED',
	SET_USER_CHANNELS_FAILED = '@@appsManagement/SET_USER_CHANNELS_FAILED',
	SET_USER_CHANNELS_STT_SUCCEED = '@@appsManagement/SET_USER_CHANNELS_STT_SUCCEED',
	SET_USER_CHANNELS_STT_FAILED = '@@appsManagement/SET_USER_CHANNELS_STT_FAILED',
	SET_USER_CHANNELS_TPP_SUCCEED = '@@appsManagement/SET_USER_CHANNELS_TPP_SUCCEED',
	SET_USER_CHANNELS_TPP_FAILED = '@@appsManagement/SET_USER_CHANNELS_TPP_FAILED'
}

export interface IAppsManagementState {
	readonly allMedias: Media[];
	readonly channelGroups: UserACL[];
	readonly channelUsers: UserACL[];
	readonly errorAllMedias: string;
	readonly errorChannelGroupsAndUser: string;
	readonly errorSelectedMedia: string;
	readonly errorUserChannels: string;
	readonly loadingMedias: boolean;
	readonly loadingChannelGroupsAndUser: boolean;
	readonly loadingUserChannels: boolean;
	readonly selectedMedia: Media | null;
	readonly userChannels: Media[];
	readonly allChannelsFilter: IChannelSearchParams | null;
	readonly loading: boolean;
	readonly error: string | null;
}

export interface Media {
	readonly encoding: boolean;
	readonly firstChunk: number;
	readonly id: number;
	readonly lastChunk: number;
	readonly mediaSource: number;
	readonly type: number;
	readonly name: string;
	readonly start: string;
	readonly end: string;
}

export interface IChannelSearchParams {
	readonly isencoded: boolean | null;
	readonly firstChunkCompare: number | null;
	readonly isFirstChunkBefore: boolean | null;
	readonly isFirstChunkAfter: boolean | null;
	readonly id: number | null;
	readonly isIdEqual: boolean | null;
	readonly isIdDifferent: boolean | null;
	readonly isIdContained: boolean | null;
	readonly lastChunkCompare: number | null;
	readonly isLastChunkBefore: boolean | null;
	readonly isLastChunkAfter: boolean | null;
	readonly mediaSource: number | null;
	readonly mediaSourceDuplicate: boolean | null;
	readonly isMediaSourceEqual: boolean | null;
	readonly isMediaSourceDifferent: boolean | null;
	readonly isMediaSourceContained: boolean | null;
	readonly type: number | null;
	readonly isTypeTV: boolean | null;
	readonly isTypeRadio: boolean | null;
	readonly name: string | null;
	readonly isNameEqual: boolean | null;
	readonly isNameDifferent: boolean | null;
	readonly isNameContained: boolean | null;
}
